import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './styles';
import { ButtonType } from './types';

interface CustomButtonProps {
  'data-testid'?: string;
  buttonSize?: SizeType;
  textSize?: SizeType;
  noMax?: boolean;
  buttonType?: ButtonType;
  readonly size?: any;
  type?: 'submit' | 'reset' | 'button';
  isSquare?: boolean;
}

export type NCRBaseButtonProps = ButtonProps & CustomButtonProps;
/* 
Because MUI decided that default is actually a white button
and MUI color names don't always make sense...
The MUI color can be applied but if a buttonType is provided,
it will be used to pick a color.
Then, actual colors will be handled in style file
Right now, 'primary' and 'alternate' are unchanged.
'White' buttonTypes have been styled.
*/
const computedColor = (type: ButtonType): any => {
  switch (type) {
    case 'white':
    case 'default':
      return 'default';
    case 'alternate':
      return 'inherit';
    case 'primary':
    default:
      return 'primary';
  }
};

export const BaseButton: React.FC<NCRBaseButtonProps> = ({
  'data-testid': testid,
  className,
  onClick,
  children,
  noMax,
  variant = 'contained',
  color,
  buttonSize,
  buttonType = 'primary',
  isSquare,
  type = 'button',
  ...rest
}): JSX.Element => {
  const stateSize = useSelector(
    (state: AppState): SizeType => state.cashierPreferences?.buttonZoomLevel || 0,
  );
  const classes = styles({ size: buttonSize ?? stateSize, buttonType, noMax, isSquare });
  const combinedClasses = `${classes.root} ${className}`;

  return (
    <Button
      data-testid={testid}
      color={color || computedColor(buttonType)}
      variant={variant}
      className={combinedClasses}
      centerRipple
      onClick={onClick}
      type={type}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default BaseButton;
